import { render } from "./Web3js.vue?vue&type=template&id=08d2d57c"
import script from "./Web3js.vue?vue&type=script&lang=js"
export * from "./Web3js.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__